export default{

	 baseURL:'http://m-ahjgjt.zpcp.org.cn/api',   //陈勇
 // baseURL:'http://192.168.1.18:7072/api',   //陈勇
	// baseURL:'m-redis.ahsjxjy.com/api',
	//  baseURL:'https://m-ahjgjxjy.com/api',      //正式
	// baseURL:'http://192.168.1.90:8080/',         //微信支付测试
	method:'POST',
	headers: {'Content-Type':'application/x-www-form-urlencoded'},
	transformRequest: [
	    function(data) {
	      	let ret = ''
	      	for (let it in data) {
	        	ret += encodeURIComponent(it) +
	          	'=' +
	          	encodeURIComponent(data[it]) +
	          	'&'
	      	}
	      	return ret
	    }
	],
	timeout: 20000
}



// WEBPACK FOOTER //
// ./src/api/base.js